import styled from 'styled-components'
import { tokens } from '../../../assets/tokens'

// Icono de lucide solo con trazo: en hover cambia el color del trazo, sin rellenar el documento
export const MTExporterStyled = styled.a`
  display: inline-flex;
  color: ${tokens.color.text.tertiary};
  transition: color 0.2s ease;

  &&:hover,
  &&:focus-visible {
    color: ${props => props.theme.primary};
    outline: none;
  }

  svg {
    fill: none;
  }
`
